export default "__VITE_ASSET__$qZd$Ujn__"